(() => {
  if (window.__duosLocationDrawersInit) return;
  window.__duosLocationDrawersInit = true;

  const open = (drawer) => {
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    if (drawer.dataset.locationHandle) {
      history.replaceState(null, '', '#prevadzka-' + drawer.dataset.locationHandle);
    }
  };
  const close = (drawer) => {
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (location.hash.startsWith('#prevadzka-')) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  };
  const closeAll = () => document.querySelectorAll('[data-location-drawer].active').forEach(close);

  const openFromHash = () => {
    const match = location.hash.match(/^#prevadzka-(.+)$/);
    if (!match) return;
    const drawer = document.querySelector(
      `[data-location-drawer][data-location-handle="${CSS.escape(decodeURIComponent(match[1]))}"]`
    );
    if (drawer && !drawer.classList.contains('active')) {
      closeAll();
      open(drawer);
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-location-drawer-open]');
    if (opener) {
      const drawer = document.getElementById(opener.dataset.locationDrawerOpen);
      if (!drawer) return;
      closeAll();
      open(drawer);
      return;
    }

    const tab = event.target.closest('[data-drawer-tab]');
    if (tab) {
      const panel = tab.closest('.duos-location-drawer__panel');
      panel.querySelectorAll('[data-drawer-tab]').forEach((t) => {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-drawer-pane]').forEach((pane) => {
        pane.hidden = pane.dataset.drawerPane !== tab.dataset.drawerTab;
      });
      return;
    }

    const drawer = event.target.closest('[data-location-drawer]');
    if (drawer && (event.target === drawer || event.target.closest('[data-location-drawer-close]'))) {
      close(drawer);
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') closeAll();
  });

  window.addEventListener('hashchange', openFromHash);
  openFromHash();
})();
